export default __webpack_public_path__ + "c42fab1.png";